/* Möblirent — PDP de renta
   Cálculo en vivo de cuota, primer pago y precio de compra final.
   No hay cifras aquí: todo sale de las variantes y los metafields. */
(function () {
  var root = document.querySelector('[data-mobli-pdp]');
  if (!root) return;

  var variants = JSON.parse(root.querySelector('[data-mobli-variants]').textContent);
  var cfg = JSON.parse(root.querySelector('[data-mobli-config]').textContent);

  var form = root.querySelector('[data-mobli-form]');
  var idInput = root.querySelector('[data-mobli-variant-input]');
  var care = root.querySelector('[data-mobli-care]');
  var careInput = care && care.querySelector('[data-mobli-care-input]');

  function money(cents) {
    var n = Math.round(cents / 100);
    return '$' + n.toLocaleString('es-CO');
  }
  function monthsOf(label) {
    var n = parseInt(String(label), 10);
    return isNaN(n) ? 1 : n;
  }
  function isPrepaid(label) {
    if (!label || cfg.payIndex < 0) return false;
    var a = String(label).toLowerCase();
    var b = String(cfg.prepaidLabel || 'adelantado').toLowerCase();
    return a.indexOf(b) > -1 || a.indexOf('adelantado') > -1 || a.indexOf('anticipado') > -1;
  }
  function selected() {
    var vals = [];
    root.querySelectorAll('[data-mobli-option]').forEach(function (fs) {
      var i = parseInt(fs.dataset.optionIndex, 10);
      var checked = fs.querySelector('[data-mobli-value]:checked');
      if (checked) vals[i] = checked.value;
    });
    return vals;
  }
  function match(vals) {
    return variants.filter(function (v) {
      return vals.every(function (val, i) { return val === undefined || v.options[i] === val; });
    })[0];
  }

  /* Precio por chip de plazo: la cuota mensual más baja disponible en ese plazo */
  function paintChipPrices() {
    root.querySelectorAll('[data-mobli-chip-price]').forEach(function (el) {
      var value = el.dataset.value;
      var pool = variants.filter(function (v) {
        return v.options[cfg.termIndex] === value && v.available;
      });
      if (!pool.length) { el.textContent = 'Agotado'; return; }
      var monthly = pool.map(function (v) {
        var m = monthsOf(value);
        var pay = cfg.payIndex > -1 ? v.options[cfg.payIndex] : '';
        return isPrepaid(pay) ? v.price / m : v.price;
      });
      el.textContent = money(Math.min.apply(null, monthly)) + '/mes';
    });
  }

  function render() {
    var vals = selected();
    var v = match(vals);
    if (!v) return;

    var term = cfg.termIndex > -1 ? vals[cfg.termIndex] : '';
    var pay = cfg.payIndex > -1 ? vals[cfg.payIndex] : '';
    var months = monthsOf(term);
    var prepaid = isPrepaid(pay);
    var monthly = prepaid ? Math.round(v.price / months) : v.price;
    var totalPlan = prepaid ? v.price : v.price * months;

    idInput.value = v.id;
    root.querySelector('[data-mobli-price]').textContent = money(monthly);
    root.querySelector('[data-mobli-per]').textContent = '/mes';

    /* Etiqueta y valor del pago anticipado por chip */
    root.querySelectorAll('[data-mobli-pay-price]').forEach(function (el) {
      var alt = match(vals.map(function (val, i) { return i === cfg.payIndex ? el.dataset.value : val; }));
      if (!alt) { el.textContent = 'No disponible'; el.closest('.mobli-chip').classList.add('is-blocked'); return; }
      el.closest('.mobli-chip').classList.remove('is-blocked');
      el.textContent = isPrepaid(el.dataset.value)
        ? money(alt.price) + ' una vez'
        : money(alt.price) + '/mes';
    });

    /* Desglose del primer pago */
    var careCents = care && careInput && careInput.checked ? parseInt(care.dataset.price, 10) : 0;
    var depositCents = 0;
    if (!careCents && cfg.salePrice > 0) depositCents = Math.round(cfg.salePrice * 0.2);

    var baseEl = root.querySelector('[data-mobli-break-base]');
    var labelEl = root.querySelector('[data-mobli-break-label]');
    labelEl.textContent = prepaid ? 'Plan completo de ' + months + ' meses' : 'Primera cuota';
    baseEl.textContent = money(v.price);

    var careRow = root.querySelector('[data-mobli-break-care]');
    careRow.hidden = !careCents;
    if (careCents) root.querySelector('[data-mobli-break-care-value]').textContent = money(careCents);

    var depRow = root.querySelector('[data-mobli-break-deposit]');
    depRow.hidden = !depositCents;
    if (depositCents) root.querySelector('[data-mobli-break-deposit-value]').textContent = money(depositCents);

    root.querySelector('[data-mobli-total]').textContent = money(v.price + careCents + depositCents);
    root.querySelector('[data-mobli-after]').textContent = prepaid
      ? 'Un solo pago. No hay cobros mensuales durante los ' + months + ' meses.'
      : 'Después, ' + money(monthly + careCents) + ' cada mes durante ' + (months - 1) + ' meses.';

    if (care) {
      var swap = care.querySelector('[data-mobli-care-swap]');
      if (swap) swap.textContent = careInput.checked
        ? 'Con Care no pagas depósito.'
        : 'Sin Care se añade un depósito de ' + money(Math.round(cfg.salePrice * 0.2)) + '.';
    }

    /* Precio de compra al final */
    var buyout = root.querySelector('[data-mobli-buyout]');
    if (buyout && cfg.salePrice > 0) {
      var credit = Math.round(totalPlan * (cfg.buyoutRate / 100));
      var finalPrice = Math.max(cfg.salePrice - credit, Math.round(cfg.salePrice * 0.1));
      buyout.querySelector('[data-mobli-buyout-price]').textContent = money(finalPrice);
      buyout.querySelector('[data-mobli-buyout-credit]').textContent = '− ' + money(credit);
    }

    var cta = root.querySelector('[data-mobli-submit]');
    cta.disabled = !v.available;
    cta.querySelector('[data-mobli-cta-label]').textContent = v.available
      ? (prepaid ? 'Pagar ' + months + ' meses' : 'Empezar mi plan')
      : 'No disponible';

    /* URL limpia, sin recargar */
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-mobli-value], [data-mobli-care-input]')) render();
  });

  /* Galería */
  root.querySelectorAll('[data-mobli-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = root.querySelector('.mobli-pdp__media-main img');
      if (main) { main.src = btn.dataset.src; main.srcset = ''; }
    });
  });

  /* Add to cart: mueble + Care en una sola llamada, con el plazo como
     atributo del carrito para que las siguientes piezas lo hereden. */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
      if (care && careInput && careInput.checked) {
        items.push({ id: parseInt(care.dataset.variantId, 10), quantity: 1 });
      }
      var vals = selected();
      var attrs = {};
      if (cfg.termIndex > -1) attrs['Plazo'] = vals[cfg.termIndex];
      if (cfg.payIndex > -1) attrs['Forma de pago'] = vals[cfg.payIndex];

      var btn = form.querySelector('[data-mobli-submit]');
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        })
        .then(function () {
          btn.disabled = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          var drawer = document.querySelector('cart-drawer-component, cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = '/cart';
        })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }

  paintChipPrices();
  render();
})();
